import getLocal from '@/app/utils/i18n';
import EfScrollAni from '@/efscrollani';
import UsStatusA from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA';
import EuStatusA from './statusA/eu/index';
import { useProductStore } from '@elem/compPage/delta-3-max-series/ProductStationProvider';
import { IPageStatus } from '../../config/IPageStatus';
import './index.scss';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    const { locale } = getLocal();

    return (
        <div className="page-product">
            {['us', 'ca'].includes(locale) && <>{pageStatus === IPageStatus.statusA && <UsStatusA />}</>}
            {['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale) && <>{pageStatus === IPageStatus.statusA && <EuStatusA />}</>}
        </div>
    );
}
